import React from 'react';
import { Instagram, Phone } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function JoinPage() {
    // You can customize these URLs and contact info
    const playStoreUrl = "https://play.google.com/store/apps/details?id=com.flexgymmobile";
    const appStoreUrl = "https://apps.apple.com/us/app/flexgym-app/id6746732181";
    const instagramUrl = "https://www.instagram.com/flexgym_tirane/";
    const phoneNumber = "+355-69-318-2776";

    const handlePhoneCall = () => {
        window.open(`tel:${phoneNumber}`);
    };

    const handleInstagram = () => {
        window.open(instagramUrl, '_blank');
    };

    const handlePlayStore = () => {
        window.open(playStoreUrl, '_blank');
    };

    const handleAppStore = () => {
        window.open(appStoreUrl, '_blank');
    };

    // Apple App Store SVG Logo
    const AppleLogo = () => (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
        </svg>
    );

    // Google Play Store SVG Logo
    const GooglePlayLogo = () => (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.61 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" fill="#34D399" />
        </svg>
    );

    return (
        <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center p-4">
            <div className="w-full max-w-md mx-auto space-y-6">

                {/* Logo and Header */}
                <div className="text-center space-y-4 mb-8">
                    <div className="mx-auto w-24 h-24 border-red-500 flex items-center justify-center bg-black">
                    <img src="/logo-with-text.png" alt="THE NOT FIT Logo" className="h-14 w-auto" />
                    </div>
                    <div>
                        <h1 className="text-2xl font-bold text-white">FlexGym</h1>
                    </div>

                    {/* Social Icons */}
                    <div className="flex justify-center space-x-4 mt-4">
                        <Button
                            variant="ghost"
                            size="sm"
                            className="rounded-full p-3 border border-red-500 hover:bg-red-500/20 text-red-500 hover:text-red-400"
                            onClick={handleInstagram}
                        >
                            <Instagram className="h-5 w-5" />
                        </Button>
                        <Button
                            variant="ghost"
                            size="sm"
                            className="rounded-full p-3 border border-red-500 hover:bg-red-500/20 text-red-500 hover:text-red-400"
                            onClick={handlePhoneCall}
                        >
                            <Phone className="h-5 w-5" />
                        </Button>
                    </div>
                </div>

                {/* Main Register CTA */}
                <div className="space-y-4">
                    <Button
                        onClick={() => window.open('/register', '_blank')}
                        className="w-full h-16 rounded-3xl bg-red-600 text-white hover:bg-red-700 flex items-center justify-center text-center transition-all duration-200 hover:scale-105 border-none"
                        variant="ghost"
                    >
                        <div className="text-center">
                            <div className="font-bold text-lg text-white">
                                BECOME A MEMBER
                            </div>
                            <div className="text-xs text-red-100">
                                Join FlexGym today
                            </div>
                        </div>
                    </Button>
                </div>

                <Button
                    onClick={handleAppStore}
                    className="w-full h-16 rounded-3xl bg-black border-2 border-red-500 text-white hover:bg-red-500/10 flex items-center justify-between px-6 text-left transition-all duration-200 hover:scale-105"
                    variant="ghost"
                >
                    <div className="flex items-center space-x-4">
                        <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center text-black">
                            <AppleLogo />
                        </div>
                        <div className="text-left">
                            <div className="font-medium text-sm text-white">
                                Download on the App Store
                            </div>
                            <div className="text-xs text-gray-300">
                                Download for iPhone
                            </div>
                        </div>
                    </div>
                    <div className="text-red-500">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                        </svg>
                    </div>
                </Button>

                {/* App Download Section */}
                <div className="space-y-4">
                    <Button
                        onClick={handlePlayStore}
                        className="w-full h-16 rounded-3xl bg-black border-2 border-red-500 text-white hover:bg-red-500/10 flex items-center justify-between px-6 text-left transition-all duration-200 hover:scale-105"
                        variant="ghost"
                    >
                        <div className="flex items-center space-x-4">
                            <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center">
                                <GooglePlayLogo />
                            </div>
                            <div className="text-left">
                                <div className="font-medium text-sm text-white">
                                    Get it on Google Play
                                </div>
                                <div className="text-xs text-gray-300">
                                    Download for Android
                                </div>
                            </div>
                        </div>
                        <div className="text-red-500">
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                            </svg>
                        </div>
                    </Button>

                </div>

                {/* Footer Links */}
                <div className="text-center mt-8 pt-4 border-t border-red-500/20">
                    <div className="flex justify-center space-x-4 text-xs text-gray-400">
                        <a href="/privacy" className="hover:text-red-400 transition-colors">
                            Privacy Policy
                        </a>
                        <span>•</span>
                        <a href="/data-deletion" className="hover:text-red-400 transition-colors">
                            Data Deletion
                        </a>
                        <span>•</span>
                        <a href="/support" className="hover:text-red-400 transition-colors">
                            Support
                        </a>
                    </div>
                </div>

            </div>
        </div>
    );
}
